import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const Unsubscribe = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "unsubscribe" */ './hocs')),
});
